import { Controller } from "@hotwired/stimulus"
import { visit } from "@hotwired/turbo"

// Периодическое обновление страницы, на которой висит контроллер.
//
// Turbo считает переходом-обновлением визит на тот же путь с action "replace",
// поэтому страница должна объявить в head:
//   <meta name="turbo-refresh-method" content="morph">
//   <meta name="turbo-refresh-scroll" content="preserve">
// Тогда DOM обновляется морфингом: элемент с контроллером сохраняется, интервал
// не пересоздаётся, прокрутка не сбрасывается.
//
// Turbo-frame для этого не годится: кадр, чей src указывает на собственный
// адрес страницы, Turbo отвергает с «has a source URL which references itself».
export default class extends Controller {
  static values = {
    interval: { type: Number, default: 3000 },
    // Верхняя граница, чтобы забытая вкладка не опрашивала сервер вечно.
    maxDuration: { type: Number, default: 600000 }
  }

  connect() {
    this.startedAt = Date.now()
    this.timer = setInterval(() => this.tick(), this.intervalValue)
  }

  disconnect() {
    this.stop()
  }

  tick() {
    if (Date.now() - this.startedAt > this.maxDurationValue) {
      this.stop()
      return
    }

    // Опрос в фоновой вкладке браузер тормозит сам, отдельная проверка
    // document.hidden только задерживала бы обновление при возврате.
    visit(window.location.href, { action: "replace" })
  }

  stop() {
    if (this.timer) clearInterval(this.timer)
    this.timer = null
  }
}
